import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  contactsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  infoCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  introRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  contactRowCard: {
    ...theme.mixins.appContainer,
    padding: theme.spacing(1.5),
  },
  contactRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  contactContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.25),
  },
  rowIcon: {
    ...theme.mixins.appIconTintSquare,
    flexShrink: 0,
    width: 48,
    height: 48,
    padding: theme.spacing(1.5),
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
    '& svg': {
      width: 24,
      height: 24,
      display: 'block',
      color: 'inherit',
    },
  },
  sendButton: {
    marginTop: theme.spacing(0.5),
    minHeight: 48,
    '& svg': {
      width: 20,
      height: 20,
    },
  },
  formCard: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
  },
  formTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  formTitleIcon: {
    color: theme.palette.primary.main,
    width: 20,
    height: 20,
    flexShrink: 0,
  },
  formFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}));
